import { createSlice } from "@reduxjs/toolkit";

interface RootState {
    notification:any
    notificationData :any,
    notificationCount:any
}

const initialState: RootState = {
  notification:false,
    notificationData :[],
    notificationCount:null
};

export const notificationSlice :any = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNotification: (state: any, { payload }) => {
      state.notification = payload;
    },
    setNotificationData: (state: any, { payload }) => {
      state.notificationData = payload;
    },
    setNotificationCount: (state: any, { payload }) => {
      state.notificationCount = payload;
    },
    
  },
  
});

export const {setNotification,setNotificationData,setNotificationCount} = notificationSlice.actions;

export const getNotificationDetails = (state: any) => state.notificationReducer;



export default notificationSlice.reducer;
